// components/RecoveryPhraseInput.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function RecoveryPhraseInput({ onRecover }) {
  const [phrase, setPhrase] = useState('');
  const [error, setError] = useState('');
const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phrase.trim()) {
      setError(t('recoveryinput.error1'));
      return;
    }

    try {
      await onRecover(phrase);
    } catch (err) {
      setError(t('recoveryinput.error2'));
    }
  };

  return (
    <div style={{ maxWidth: '500px', margin: '0 auto', padding: '24px', background: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
 }}>
      <h2>{t('recoveryinput.titre')}</h2>
      <p style={{ marginBottom: '20px' }}>
        {t('recoveryinput.intro')}
      </p>

      {error && (
        <div style={{ color: '#e74c3c', marginBottom: '16px' }}>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <textarea
          value={phrase}
          onChange={(e) => setPhrase(e.target.value)}
          placeholder={t('recoveryinput.placeholder')}
	rows={4}
          style={{
          width: '100%',
          boxSizing: 'border-box',
          padding: '12px',
          border: '1px solid #ccc',
          borderRadius: '6px',
          resize: 'vertical',
          fontSize: '15px',
          marginBottom: '16px'
        }}

        />

        <button
          type="submit"
          style={{
            padding: '12px 24px',
            background: '#3498db',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            width: '100%'
          }}
        >
          {t('recoveryinput.button')}
        </button>
      </form>
    </div>
  );
}